import {
  CompetitorTeaser,
  ExampleRecommendations,
  FinalCta,
  Hero,
  HowItWorks,
  WhatWeCheck,
} from '@/components/landing/landing-sections';
import { FaqSection } from '@/components/landing/faq-section';

export default function LandingPage() {
  return (
    <>
      <Hero />
      <HowItWorks />
      <WhatWeCheck />
      <ExampleRecommendations />
      <CompetitorTeaser />
      <FaqSection />
      <FinalCta />
    </>
  );
}
